import { useGetOrganizationInfo } from "features/organization/hooks/useGetOrganizationInfo";
import { useGetUserInfo } from "features/users/hooks/useGetUserInfo";

export type Response = {
    areTermsAndConditionsUpdated: boolean;
    isLoading: boolean;
};

export default function useAreTermsAndConditionsUpdated(): Response {
    const { data: user, isLoading: isLoadingUser } = useGetUserInfo();
    const { data: organization, isLoading: isLoadingOrganization } = useGetOrganizationInfo();
    const isLoading = isLoadingUser || isLoadingOrganization;
    const areTermsAndConditionsUpdated =
        user?.userInOrganization?.acceptedTermsReference === organization?.organizationTerms?.termsAndConditionsReference &&
        user?.userInOrganization?.acceptedPrivacyPolicyReference === organization?.organizationTerms?.privacyPolicyReference &&
        user?.userInOrganization?.acceptedPersonalDataTreatmentReference ===
            organization?.organizationTerms?.personalDataTreatmentReference;

    return { isLoading, areTermsAndConditionsUpdated };
}
